// extracted by mini-css-extract-plugin
export default {"title":"Title_title__dxOfy","subtitle":"Title_subtitle__1ce3y","normal":"Title_normal__sbs8y"};